import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ProductGallery from "../components/ProductGallery";
import SliderSimilier from "../components/SliderSimilier";
import Footer from "../components/Footer";
import { httpReauest } from "../utils/httpRequest";
import { CDN_BASE_URL } from "../config";
import { CartContext } from "../context/CartContext";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { toast } from "react-toastify";
import { calculateGoldPrice } from "../utils/getPrice"; // اگر این‌ها هم نیاز به ترجمه دارند، باید داخل تابع getPrice تغییر کنند
import { priceComma } from "../utils/priceComma"; // اگر این‌ها هم نیاز به ترجمه دارند، باید داخل تابع priceComma تغییر کنند
import { Helmet } from "react-helmet";
import { BsShare, BsTelegram } from "react-icons/bs";
import { FaTelegramPlane } from "react-icons/fa";
import Header from "components/header";
import { useTranslation } from "react-i18next"; // Import useTranslation
import Reveal from "motion/Reveal";
import ProductComments from "components/ProductComments";
import { FavoriteContext } from "context/FavoriteContext";
import { Heart } from "iconsax-react";

function getFullImageUrl(image) {
  if (!image) return null;
  if (image.startsWith("http")) {
    return image;
  }
  return CDN_BASE_URL + image;
}

const ProductDetailsPage = () => {
  const [productId, setProductId] = useState(null); // Changed initial state to null
  const [subProducts, setsubProducts] = useState([]); // Changed initial state to empty array
  const [count, setCount] = useState(1);
  const [loading, setloading] = useState(true);
  const [selected, setselected] = useState(null); // Changed initial state to null
  const [selectedcolor, setselectedcolor] = useState(null); // Changed initial state to null
  const [selectedStorage, setSelectedStorage] = useState(null); // Changed initial state to null
  const [balance, setBalance] = useState(null); // Changed initial state to null
  const [onCart, setonCart] = useState(null); // Changed initial state to null
  const [countProduct, setcountProduct] = useState(1);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ImageGallery, setImageGallery] = useState([]);
  const { name } = useParams();

  const { cart, setCart } = useContext(CartContext);
  const { favorite, setfavorite } = useContext(FavoriteContext);

  const { t, i18n } = useTranslation("global"); // Destructure t and i18n from useTranslation

  async function getId() {
    setloading(true);
    try {
      const response = await httpReauest("GET", `/product/${name}`, {}, {});
      const product = response.data.data.product;
      const subproducts = response.data.data.subproducts;

      setProductId(product);
      setsubProducts(subproducts);

      if (subproducts.length) {
        handlecolor(subproducts);
      }

      const allImagesSet = new Set();
      if (product.cover) {
        allImagesSet.add(getFullImageUrl(product.cover));
      }

      subproducts.forEach((item) => {
        if (item.images && Array.isArray(item.images)) {
          item.images.forEach((img) => {
            if (img) allImagesSet.add(getFullImageUrl(img));
          });
        } else if (item.image) {
          allImagesSet.add(getFullImageUrl(item.image));
        }
      });

      setImageGallery(Array.from(allImagesSet));
      setCurrentIndex(0);

      const isoncart = cart?.find((item) => item?._id == product._id); // Changed to product._id
      if (isoncart) {
        setonCart(isoncart);
      }

      const firstColor = subproducts[0]?.color;
      if (firstColor) {
        const currentColorProducts = subproducts.filter(
          (item) => item.color === firstColor
        );

        const uniqueStorages = [];
        const seenStorages = new Set();

        currentColorProducts.forEach((item) => {
          const storageValue = item.storage || item.size;
          if (storageValue && !seenStorages.has(storageValue)) {
            uniqueStorages.push(item);
            seenStorages.add(storageValue);
          }
        });

        setselectedcolor(firstColor);
        setSizes(uniqueStorages);

        const firstSize = currentColorProducts[0];
        if (firstSize) {
          setSelectedStorage(firstSize.storage || firstSize.size);
          setBalance(firstSize);
        }
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      toast.error(t("productDetails.fetchError"));
    } finally {
      setloading(false);
    }
  }

  function handlecolor(subProductsArray) {
    // Renamed parameter for clarity
    const groupedByColor = subProductsArray?.reduce((acc, item) => {
      if (!acc[item.color]) {
        acc[item.color] = [];
      }
      acc[item.color].push(item);
      return acc;
    }, {});

    if (groupedByColor && Object.keys(groupedByColor).length > 0) {
      const result = Object.entries(groupedByColor)
        .map(([color, products]) => {
          const productWithImage = products.find(
            (item) => item.images?.[0] || item.image
          ); // Check both images and image
          if (productWithImage) {
            return {
              color,
              image: getFullImageUrl(
                productWithImage.images?.[0] || productWithImage.image
              ), // Use first image or single image
            };
          }
          return null;
        })
        .filter(Boolean);

      setColors(result);
    } else {
      console.error("No items grouped by color or groupedByColor is undefined");
    }
  }

  function handleChose(color) {
    const currentColorProducts = subProducts.filter(
      (item) => item.color === color
    );
    const otherColorProducts = subProducts.filter(
      (item) => item.color !== color
    );

    const currentColorImages = [];
    currentColorProducts.forEach((item) => {
      if (item.images && Array.isArray(item.images)) {
        item.images.forEach((img) => {
          currentColorImages.push(getFullImageUrl(img));
        });
      } else if (item.image) {
        currentColorImages.push(getFullImageUrl(item.image));
      }
    });

    const otherImages = [];
    otherColorProducts.forEach((item) => {
      if (item.images && Array.isArray(item.images)) {
        item.images.forEach((img) => {
          otherImages.push(getFullImageUrl(img));
        });
      } else if (item.image) {
        otherImages.push(getFullImageUrl(item.image));
      }
    });

    const allGallery = [...currentColorImages, ...otherImages];
    if (productId?.cover) {
      allGallery.push(getFullImageUrl(productId.cover));
    }

    setImageGallery(Array.from(new Set(allGallery))); // Remove duplicates
    setCurrentIndex(0);

    const uniqueStorages = [];
    const seen = new Set();
    currentColorProducts.forEach((item) => {
      const value = item.storage || item.size;
      if (value && !seen.has(value)) {
        seen.add(value);
        uniqueStorages.push(item);
      }
    });

    setselectedcolor(color);
    setSizes(uniqueStorages);

    const firstMatch = currentColorProducts[0];
    if (firstMatch) {
      setSelectedStorage(firstMatch.storage || firstMatch.size);
      setBalance(firstMatch);
    }
  }

  function handleBalance(e) {
    const foundItem = subProducts.find(
      (item) =>
        item.color === selectedcolor &&
        (item.storage ? item.storage : item?.size) === e
    );
    setBalance(foundItem);
    setSelectedStorage(e); // Update selectedStorage state
  }

  useEffect(() => {
    getId();
    window.scrollTo({ top: 0 });
  }, [name, cart]); // Added cart to dependencies to re-evaluate onCart status

  function handleAdd() {
    if (balance?.balance === 0) {
      return toast.error(t("productDetails.noProductAvailable"));
    }
    if (subProducts?.length) {
      if (!selectedcolor || !balance) {
        return toast.warn(t("productDetails.selectSpecsWarning"));
      }
      const newCartItem = {
        name: productId?.name,
        color: selectedcolor,
        size: balance?.storage ? balance?.storage : balance?.size,
        img: getFullImageUrl(balance?.images?.[0] || balance?.image), // Ensure image is full URL
        price: balance?.special_price ? balance?.special_price : balance?.price,
        count: count,
        id: balance?._id, // Use _id for unique identification
      };

      setCart((prevCart) => {
        const cartExited = prevCart.find((e) => e.id === newCartItem.id);
        if (cartExited) {
          if (cartExited.count + newCartItem.count > balance.balance) {
            return toast.error(t("productDetails.notEnoughProduct"));
          }
          return prevCart.map((item) =>
            item.id === cartExited.id
              ? { ...item, count: item.count + newCartItem.count }
              : item
          );
        } else {
          return [...prevCart, newCartItem];
        }
      });
      toast.success(t("productDetails.addedToCart"));
    } else {
      // Handle simple product without sub-products
      if (productId?.balance === 0) {
        return toast.error(t("productDetails.noProductAvailable"));
      }
      if (count > productId?.balance) {
        return toast.error(t("productDetails.notEnoughProduct"));
      }
      const newCartItem = {
        name: productId?.name,
        img: getFullImageUrl(productId?.cover),
        price: productId?.special_price
          ? productId?.special_price
          : productId?.price,
        count: count,
        id: productId?._id,
      };

      setCart((prevCart) => {
        const cartExited = prevCart.find((e) => e.id === newCartItem.id);
        if (cartExited) {
          if (cartExited.count + newCartItem.count > productId.balance) {
            return toast.error(t("productDetails.notEnoughProduct"));
          }
          return prevCart.map((item) =>
            item.id === cartExited.id
              ? { ...item, count: item.count + newCartItem.count }
              : item
          );
        } else {
          return [...prevCart, newCartItem];
        }
      });
      toast.success(t("productDetails.addedToCart"));
    }
  }

  function handleDelete() {
    const newCart = cart.filter(
      (e) => e.id !== (selected ? selected._id : productId._id)
    ); // Use .id for consistency
    setCart(newCart);
    setonCart(false);
    toast.info(t("productDetails.removedFromCart"));
  }

  // NOTE: handleAddCount and handleDecreseCount seem to be for a different cart logic or are incomplete
  // as they directly manipulate cart without checking if the item is already selected/subproduct
  // and seem to re-add the item. I'll keep them translated but suggest reviewing their logic.
  function handleAddCount() {
    const currentProduct = selected || productId;
    if (currentProduct.balance < countProduct + 1) {
      return toast.error(t("productDetails.notEnoughProduct"));
    }
    setcountProduct(countProduct + 1);
    // The cart manipulation logic here seems to re-add the item.
    // It should ideally update the count of an existing item in cart.
    // For now, only the countProduct state is updated.
  }

  function handleDecreseCount() {
    if (countProduct === 1) {
      return; // Cannot decrease below 1
    }
    setcountProduct(countProduct - 1);
    // Same note as handleAddCount - cart manipulation logic needs review.
  }

  const handleChangeImage = (index) => {
    setCurrentIndex(index);
  };

  const isFavorite = favorite.find((item) => item.url === productId?.url);

  function handleAddFavorite(e) {
    e.preventDefault();
    if (isFavorite) {
      const newFavorite = favorite.filter((c) => c.url !== productId.url);
      setfavorite(newFavorite);
      toast.info(t("productDetails.removedFromFavorites"));
    } else {
      setfavorite((cur) => [...cur, productId]);
      toast.success(t("productDetails.addedToFavorites"));
    }
  }

  if (loading || !productId) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-xl font-semibold">{t("productDetails.loading")}</p>
      </div>
    );
  }

  return (
    <div className="mt-[108px] lg:mt-[83px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {i18n.language === "fa"
            ? productId?.name
            : productId?.name_en || productId?.name}
        </title>
        <meta
          name="description"
          content={
            i18n.language === "fa"
              ? productId?.desc
              : productId?.desc_en || productId?.desc
          }
        />
        <meta
          name="og:description"
          content={
            i18n.language === "fa"
              ? productId?.desc
              : productId?.desc_en || productId?.desc
          }
        />
        <meta
          name="og:title"
          content={
            i18n.language === "fa"
              ? productId?.name
              : productId?.name_en || productId?.name
          }
        />
      </Helmet>
      <Header />
      <div className=" overflow-hidden pb-10 bg-white ">
        <div className="lg:grid grid-cols-2 flex flex-col justify-center items-center container">
          <h1 className="font-bold text-[18px] w-full lg:text-[27px] py-2 border-b lg:hidden">
            {i18n.language === "fa"
              ? productId?.name
              : productId?.name_en || productId?.name}
          </h1>
          <div className=" w-full z-10 ">
            {subProducts?.length > 0 && ( // Ensure subProducts exist
              <Reveal>
                <ProductGallery
                  currentIndex={currentIndex}
                  setCurrentIndex={setCurrentIndex}
                  images={ImageGallery}
                />
              </Reveal>
            )}
          </div>
          <div className="col-span-1 w-full lg:p-5">
            <Heart
              onClick={handleAddFavorite}
              className="cursor-pointer"
              size={26}
              color={isFavorite ? "red" : "#000"}
              variant={!isFavorite ? "Linear" : "Bold"}
            />
            <Reveal head>
              <div className="">
                <h1 className="font-bold text-[18px] w-full lg:text-[27px] pb-3 pt-1 border-b hidden lg:block">
                  {i18n.language === "fa"
                    ? productId?.name
                    : productId?.name_en || productId?.name}
                </h1>
                <p className="py-3">
                  {" "}
                  {i18n.language === "fa"
                    ? productId?.desc
                    : productId?.desc_en || productId?.desc}
                </p>
              </div>
            </Reveal>

            <Reveal head>
              <div className="grid gap-[12px] border-t pt-3">
                {colors.length > 0 && ( // Only show colors if available
                  <div className=" flex-wrap">
                    <span className="font-[500] text-[16px] w-full">
                      <strong> {t("productDetails.colorLabel")}</strong>{" "}
                      {selectedcolor}
                    </span>
                    <div className="flex gap-2 items-center mt-2">
                      <div className="flex flex-wrap gap-2">
                        {colors.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setselectedcolor(item.color);
                              handleChose(item.color);
                            }}
                            className={`cursor-pointer border rounded p-1 ${
                              selectedcolor === item.color
                                ? "ring-2 ring-blue-500"
                                : ""
                            }`}
                          >
                            <img
                              src={item.image}
                              alt={item.color}
                              className="w-20 h-20 object-cover rounded"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {sizes.length > 0 ? ( // Only show sizes if available
                  <div className="mt-2">
                    <span className="font-[500] text-[16px] block mb-2">
                      <strong>{t("productDetails.storageLabel")}</strong>{" "}
                      {selectedStorage}
                    </span>
                    <div className="flex flex-wrap gap-3">
                      {sizes.map((item, index) => {
                        const storageValue = item.storage || item.size;
                        const isSelected = selectedStorage === storageValue;

                        return (
                          <button
                            type="button" // Use type="button" for non-submit buttons
                            key={index}
                            onClick={() => {
                              setSelectedStorage(storageValue);
                              handleBalance(storageValue);
                            }}
                            className={`rounded-xl p-3 border text-sm transition ${
                              isSelected
                                ? "border-blue-600 ring-2 ring-blue-400 text-blue-800 font-bold"
                                : "border-gray-300 hover:border-blue-400"
                            }`}
                          >
                            <div className="text-center min-w-[70px] px-2">
                              <h4 className="text-[16px] font-bold">
                                {storageValue}
                              </h4>
                              <p className="text-[15px] text-gray-600 mt-1">
                                {item.special_price
                                  ? `${priceComma(item.special_price, 2)} ${t(
                                      "toman"
                                    )}`
                                  : `${priceComma(item.price, 2)} ${t(
                                      "toman"
                                    )}`}
                              </p>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
                <div className="flex gap-2">
                  {!sizes.length && balance ? ( // Only show balance if a balance item is selected
                    <span className="bg-green-200 px-3 py-2 rounded-lg w-fit">
                      {priceComma(balance.price, 2)} {t("toman")}
                    </span>
                  ) : null}
                  {balance && ( // Only show balance if a balance item is selected
                    <span className="bg-gray-200 px-3 py-2 rounded-lg w-fit">
                      {t("productDetails.balanceLabel")} : {balance?.balance}
                    </span>
                  )}
                </div>
              </div>
            </Reveal>

            <div className="my-8 flex gap-2 items-center">
              <span className="py-1 w-fit flex items-center border rounded-full mx-2">
                <button
                  type="button"
                  onClick={() => {
                    if (
                      count === (balance?.balance || productId?.balance) ||
                      balance?.balance === 0 ||
                      productId?.balance === 0
                    ) {
                      return;
                    } else setCount(count + 1);
                  }}
                  className=" px-2 py-1 "
                >
                  <FaPlus />
                </button>
                <span className="px-2 py-1">{count}</span>
                <button
                  type="button"
                  onClick={() => {
                    if (count === 1) {
                      return;
                    } else setCount(count - 1);
                  }}
                  className="px-2 py-1 "
                >
                  <FaMinus />
                </button>
              </span>

              <button onClick={handleAdd} className=" btn btn-primary">
                {t("productDetails.addToCartButton")}
              </button>
            </div>
          </div>
          <div className="col-span-full mt-6 lg:mt-16 w-full">
            <h3 className="font-bold text-[18px] lg:text-[27px] border-b pb-3">
              {t("productDetails.moreDescriptionTitle")}
            </h3>
            <div
              dir="rtl"
              className="lg:text-[16px] text-[14px] pt-3"
              dangerouslySetInnerHTML={{
                __html:
                  i18n.language === "fa"
                    ? productId?.more_desc
                    : productId?.more_desc_en || productId?.more_desc,
              }}
            />
          </div>
          <ProductComments data={productId} />
        </div>

        <div className="w-full mt-10">
          <span className="font-bold text-black text-[30px] lg:text-[40px] pt-8 text-center mb-6 block ">
            {t("productDetails.relatedProductsTitle")}
          </span>
          {productId?.category && (
            <SliderSimilier category={productId?.category?.url} />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetailsPage;
